// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bar = "HorizontalBarChart__bar__E0PN-";
export const barLabel = "HorizontalBarChart__barLabel__B5BEn";
export const barLabelMarginRight = "var(--bar-label-margin-h)";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const horizontalBarChart = "HorizontalBarChart__horizontalBarChart__wuZRY";
export const legendWrapper = "HorizontalBarChart__legendWrapper__Mjdz0";
export const medium = "500";
export const member = "HorizontalBarChart__member__Zncge";
export const others = "HorizontalBarChart__others__gFXZE";
export const outerLabel = "HorizontalBarChart__outerLabel__UYmAs";
export const peers = "HorizontalBarChart__peers__KdHBA";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textLeft = "HorizontalBarChart__textLeft__zPYrW";
export const zeroValue = "HorizontalBarChart__zeroValue__rtNfk";